/**
 * Entry point for development and production PWA builds.
 * Packaged (NPM) builds go through `index-umd.js`
 */

import 'regenerator-runtime/runtime';

import App from './App.js';
import React from 'react';
import ReactDOM from 'react-dom';

/**
 * EXTENSIONS
 * =================
 *
 * Importing and modifying the extensions our app uses HERE allows us to leverage
 * tree shaking and a few other niceties. However, by including them here they become
 * "baked in" to the published application.
 *
 * Depending on your use case/needs, you may want to consider not adding any extensions
 * by default HERE, and instead provide them via the extensions configuration key or
 * by using the exported `App` component, and passing in your extensions as props using
 * the defaultExtensions property.
 */
import OHIFVTKExtension from '@ohif/extension-vtk';
import OHIFDicomHtmlExtension from '@ohif/extension-dicom-html';
import OHIFDicomMicroscopyExtension from '@ohif/extension-dicom-microscopy';
import OHIFDicomPDFExtension from '@ohif/extension-dicom-pdf';

/*
 * Default Settings
 */
let config = {};
var oParametre = {};

if (window.location.search.length > 1) {
    for (var aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&"); nKeyId < aCouples.length; nKeyId++) {
        aItKey = aCouples[nKeyId].split("=");
        oParametre[unescape(aItKey[0])] = aItKey.length > 1 ? unescape(aItKey[1]) : "";
    }
}
if(oParametre.kpc){
    console.log("Parametre kpc received");
}

var res = getValidation(oParametre.kpc);


function getValidation(oParametre){
    console.log("IN FUNCTION");
    /*return new Promise( function (resolve, reject) {*/
        /*
                try {
                    var url = new URL("https://istbox-orel/php/includes/checkValidity.php");
                    url.searchParams.append("ref", oParametre);
                    var url_string = url.toString();
                    fetch(url_string , {
                            method: 'GET',
                            mode: "no-cors"
                        }).then(
                        function(response){
                            if(response.ok) {
                                console.log(response);
                                resolve("SUCCESS");
                            }else{
                                console.log("PROMISE ERROR");
                                reject("Promise error");
                            }

                        },
                        function(error){
                            console.log("ERROR RECEIBED: "+error);
                            reject("ERROR");
                        }
                    )
                }catch(ex){
                    reject("EXCEPTION");
                }
            })*/

        function reqListener() {
            var response = JSON.parse(this.responseText);
            if(response.success && response.status==200){
                if (window) {
                    config = window.config || {};
                }

                const appProps = {
                    config,
                    defaultExtensions: [
                        OHIFVTKExtension,
                        OHIFDicomHtmlExtension,
                        OHIFDicomMicroscopyExtension,
                        OHIFDicomPDFExtension,
                    ],
                };

                /** Create App */
                const app = React.createElement(App, appProps, null);

                /** Render */
                ReactDOM.render(app, document.getElementById('root'));
            }else{
                console.log("Nothing will be shown");
            }
        }

        var url = new URL("https://"+window.config.selfServer+"/php/includes/checkValidity.php");
        url.searchParams.append("dt", oParametre);
        var url_string = url.toString();
        var oReq = new XMLHttpRequest();
        oReq.addEventListener("load", reqListener);
        oReq.open("GET", url_string);
        oReq.send();
    //}
}



